import ajax from 'Site/js/util/ajax.fetch';
import Infinite from 'Site/component/Infinite.vue';
import Media from 'Media/component/Media.vue';
import { mapActions, mapState } from 'vuex';

export default {
    components: {
        Infinite,
        Media
    },
    computed: mapState({
        allMedia: state => state.config.data.media,
        id: state => state.config.data.id,
        t: state => state.t
    }),
    data: {
        canLoadMore: true,
        loading: false,
        offset: 10
    },
    methods: {
        ...mapActions(['notify', 'showConfirm', 'showMediaViewer']),
        fetch() {
            if (!this.canLoadMore) {
                return;
            }
            this.loading = true;
            ajax.get('wall', {
                foreign: this.id,
                type: this.type,
                'media-only': true,
                'start-index': this.offset,
                'max-results': 25
            }).then((response) => {
                this.loading = false;
                this.offset += 25;
                if (response.items && response.items.length) {
                    response.items.forEach((item) => {
                        this.allMedia.push(item);
                    });
                } else {
                    this.canLoadMore = false;
                }
            });
        },
        mediaViewer(start) {
            this.showMediaViewer({ media: this.allMedia, start });
        },
        removeMedia(mediaItem) {
            this.showConfirm({
                text: this.t.remove_media_confirm,
                callback: () => {
                    const index = this.allMedia.indexOf(mediaItem);
                    this.allMedia.splice(index, 1);

                    ajax.update('wall', {
                        id: mediaItem.post,
                        postId: mediaItem.post,
                        foreign: this.id,
                        type: this.type,
                        removeMedia: mediaItem.id
                    }).then((response) => {
                        this.notify({ msg: response.message });
                    });
                }
            });
        }
    }
};
